module.exports = __webpack_public_path__ + "img/icon-question-rating-heart.63c4bdbd.svg";